import CheatModeLinkEdit from './cheat-mode-link.edit';
import CheatModeLinkShow from './cheat-mode-link.show';

export default {
  edit: CheatModeLinkEdit,
  show: CheatModeLinkShow,
};
